<script lang="ts">
	import Modal from './Modal.svelte';
	import { modals, closeModal, transitionModal } from '$lib/stores/modalStore';

	function isLazyModal(component: any) {
		return typeof component.prototype === 'undefined';
	}

	async function getComponent(component: any) {
		return component().then((res: any) => res.default);
	}

	$: currentModal = $modals[$modals.length - 1];
	$: currentModalDissmissable = currentModal?.config?.dismissable ?? false;
	$: visible = $modals.length > 0;
	$: nonblocking = currentModal?.config?.nonBlocking ?? false;

	function close() {
		if (!currentModal?.config?.dismissable) return;
		closeModal(currentModal.id);
	}
</script>

<div
	class="modals {currentModalDissmissable && 'dismissable'}"
	class:visible
	class:nonblocking
	on:click|self={close}
>
	{#each $modals as modal, i (i)}
		{#await getComponent(() => import(`$lib/components/modals/${modal.name}.svelte`))}
			<!-- <Loader /> -->
			<div />
		{:then component}
			{#key modal.id}
				<Modal
					open={i === $modals.length - 1 && $transitionModal !== modal.id}
					config={modal.config}
					self={modal}
				>
					<svelte:component this={component} {...modal.props} id={modal.id} />
				</Modal>
			{/key}
		{/await}
	{/each}
</div>

<style lang="scss">
	.modals {
		position: fixed;
		inset: 0;
		z-index: v(z-index-modals);

		&:not(.nonblocking) {
			background: color(modal__backdrop);
		}

		&.nonblocking {
			pointer-events: none;

			:global(.modal) {
				pointer-events: auto;
				box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
			}
		}

		@include transition(all);

		&.dismissable {
			cursor: pointer;
		}

		&:not(.dismissable) {
			cursor: not-allowed;
		}

		&:not(.visible) {
			background: color(modal__backdrop__hidden);
			pointer-events: none;
		}
	}
</style>
